// apps/web/src/components/backup/BackupManager.tsx
// Backup + restore management.

import { useState } from 'react';
import { apiClient } from '../../lib/apiClient';

interface BackupRun {
  id: string;
  status: string;
  createdAt: string;
}

export function BackupManager() {
  const [runs, setRuns] = useState<BackupRun[]>([]);
  const [message, setMessage] = useState<string | null>(null);

  const runBackup = async () => {
    try {
      const res = await apiClient.post('/maintenance/backup');
      const created = res.data as BackupRun;
      setRuns([created, ...runs]);
      setMessage('Backup started.');
    } catch (err) {
      setMessage((err as { message?: string })?.message ?? 'Backup failed.');
    }
  };

  return (
    <div className="backup-manager">
      <div className="header">
        <h2>Backup & Restore</h2>
        <button type="button" className="btn btn-primary" onClick={runBackup}>
          Run Backup
        </button>
      </div>
      {message && <p className="notice">{message}</p>}
      <div className="manager-grid">
        {runs.length === 0 ? (
          <div className="empty-state">No backups yet.</div>
        ) : (
          runs.map((r) => (
            <div className="manager-card" key={r.id}>
              <h3>Backup {r.id.slice(0, 8)}</h3>
              <p className="status-badge">{r.status}</p>
              <p>{r.createdAt}</p>
              <div className="actions">
                <button className="btn btn-warning">Restore</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}